// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first-page {
    background-color: red;
    height: 290mm;
    padding: 0;
        color: white !important;
    /* padding: 20mm; */
}

.thankyou-box {
    width: 100%;
        padding-top: 40mm;
    color: white !important;
}
.footer{
    position: static;
    margin-top: 98%;
    
    text-decoration: underline;

}
`, "",{"version":3,"sources":["webpack://./src/views/admin/default/Report/FifthPage/index.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,aAAa;IACb,UAAU;QACN,uBAAuB;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;QACP,iBAAiB;IACrB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,eAAe;;IAEf,0BAA0B;;AAE9B","sourcesContent":[".first-page {\n    background-color: red;\n    height: 290mm;\n    padding: 0;\n        color: white !important;\n    /* padding: 20mm; */\n}\n\n.thankyou-box {\n    width: 100%;\n        padding-top: 40mm;\n    color: white !important;\n}\n.footer{\n    position: static;\n    margin-top: 98%;\n    \n    text-decoration: underline;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
